import React, { useState, useEffect, forwardRef, useRef, useImperativeHandle } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom'
import {
  Button,
  Row,
  Col,
  Input,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  EditorState,
  RichUtils,
  convertFromHTML,
  ContentState,
  KeyBindingUtil,
  Modifier,
  convertToRaw,
  convertFromRaw,
  ContentBlock,
  genKey,
  SelectionState,
  DefaultDraftBlockRenderMap,
  CompositeDecorator,
} from 'draft-js';
import 'draft-js/dist/Draft.css';
import Editor from '@draft-js-plugins/editor'
import createHighlightPluginOk from './editor_plugins/highlightPluginOk'
// import createHighlightPluginNotOk from './editor_plugins/highlightPluginNotOk'
import createHighlightPluginNotDict from './editor_plugins/highlightPluginDict'
import createStrikethroughPlugin from './editor_plugins/strikethroughPlugin'

import createStyleRealtimePast from './editor_plugins/styleRealtimePast'

// import addLinkPlugin from './editor_plugins/addLinkPlugin'
import BlockStyleToolbar, { getBlockStyle } from "./editor_block_styles/BlockStyleToolbar"
import { stateToHTML } from 'draft-js-export-html';
import { isMobile } from 'react-device-detect';
import Immutable from 'immutable'
import { getSelectionEntity, getSelectionText } from 'draftjs-utils'

// @draft-js-plugins experiments
import createInlineToolbarPlugin from '@draft-js-plugins/inline-toolbar';
// import createInlineToolbarPlugin from '../../../tools/@draft-js-plugins/inline-toolbar';
import '@draft-js-plugins/inline-toolbar/lib/plugin.css';
import SampleButton from './draft_resources/SampleButton'
import StrikethroughButton from './draft_resources/StrikethroughButton'
import PlayButton from './draft_resources/PlayButton'
import UpDownButton from './draft_resources/UpDownButton'
import TimeSpan from './draft_resources/TimeSpan'

const Diff = require('diff');

const TokenSpan = (props) => {

   return (
     <span data-offset-key={props.offsetkey} style={{
       // fontWeight: 'bold',
       // color: 'red',
     }}>
       {props.children}
     </span>
   );
 };

 function getEntityStrategy(mutability) {
   return function(contentBlock, callback, contentState) {
     contentBlock.findEntityRanges(
       (character) => {
         const entityKey = character.getEntity();
         if (entityKey === null) {
           return false;
         }
         return contentState.getEntity(entityKey).getMutability() === mutability;
       },
       callback
     );
   };
 }

function getEntities(editorState, entityType = null) {
 const content = editorState.getCurrentContent();
 const entities = [];
 content.getBlocksAsArray().forEach((block) => {
   let selectedEntity = null;
   block.findEntityRanges(
     (character) => {
       if (character.getEntity() !== null) {

         const entity = content.getEntity(character.getEntity());

         if (!entityType || (entityType && entity.getType() === entityType)) {
           selectedEntity = {
             entityKey: character.getEntity(),
             blockKey: block.getKey(),
             entity: content.getEntity(character.getEntity()),
             // data: entity.getData(),
           };
           return true;
         }
       }
       return false;
     },
     (start, end) => {
       entities.push({ ...selectedEntity, start, end });
     });
 });
 return entities;
}


const decorator = new CompositeDecorator([
  // {
  //   strategy: getEntityStrategy('IMMUTABLE'),
  //   component: TokenSpan,
  // },
  {
    strategy: getEntityStrategy('MUTABLE'),
    component: TokenSpan,
  },
  // {
  //   strategy: getEntityStrategy('SEGMENTED'),
  //   component: TokenSpan,
  // },
]);


// NaranciaEditor8
const NaranciaEditor8 = forwardRef((props, ref) => {

  // function from parent
  useImperativeHandle(ref, () => ({

    getBlocks() {
      let rawData = convertToRaw(editorState.getCurrentContent())
      return rawData.blocks
    },

    getRaw() {
      let rawData = convertToRaw(editorState.getCurrentContent())
      return rawData
    },

  }));

  // use history
  let navigate = useNavigate()
  let dispatch = useDispatch();

  let editor = useRef(null);

  let [editorState, setEditorState] = useState(
    () => EditorState.createEmpty(),
  );

  let [{ plugins, InlineToolbar }] = useState(() => {

    const inlineToolbarPlugin = createInlineToolbarPlugin();
    const { InlineToolbar } = inlineToolbarPlugin;

    // const highlightPluginNotOk = createHighlightPluginNotOk()
    const styleRealtimePast = createStyleRealtimePast()
    // console.log("styleRealtimePast:", styleRealtimePast)

    const highlightPluginNotDict = createHighlightPluginNotDict()
    const strikethroughPlugin = createStrikethroughPlugin()
    // console.log("strikethroughPlugin:", strikethroughPlugin)
    const highlightPluginOk = createHighlightPluginOk()

    const plugins = [inlineToolbarPlugin, styleRealtimePast, highlightPluginNotDict, strikethroughPlugin, highlightPluginOk];
    return {
      plugins,
      InlineToolbar
    };
  });

  let [lastKey1, setLastKey1] = useState("")
  let [top, setTop] = useState(0)
  let [left, setLeft] = useState(0)
  // let [showTooltip, setShowTooltip] = useState(false)
  // let [healthScore, setHealthScore] = useState(-1)

  let [removed , setRemoved] = useState("")
  let [added , setAdded] = useState("")
  let [replacedList, setReplacedList] = useState([])
  let [lastAddOrRemove, setLastAddOrRemove] = useState("")

  let [hiragana, setHiragana] = useState("")
  // let [kanji, setKanji] = useState("")
  let [wordCategory, setWordCategory] = useState("")

  // let [editorStateUpdated, setEditorStateUpdated] = useState(false)

  let [updateTimeout, setUpdateTimeout] = useState(null)

  let [selectAndPlayTimeout, setSelectAndPlayTimeout] = useState(null)


  // componentDidMount
  useEffect(() => {

    if (props.draftjsDefault) {

      let _state = convertFromRaw(props.draftjsDefault);
      setEditorState(EditorState.createWithContent(_state, decorator))

    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.draftjsDefault]);



  // // editor update
  // useEffect(() => {
  //
  //   if (updateTimeout) {
  //     clearTimeout(updateTimeout)
  //   }
  //
  //   let _timeout = setTimeout(
  //     props.editorStateUpdated()
  //     , 1000)
  //
  //   setUpdateTimeout(_timeout)
  //
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [editorStateUpdated]);

  // // player time
  // useEffect(() => {
  //
  //   // console.log("props.blockIndexes: ", props.blockIndexes)
  //   // console.log("props.playingBlockIndex: ", props.playingBlockIndex)
  //
  //   if ( props.blockIndexes.indexOf(props.playingBlockIndex) !== -1) {
  //
  //     // let _draftjs = props.item.draftjs
  //     let _draftjs = convertToRaw(editorState.getCurrentContent())
  //     let _blocks = _draftjs.blocks
  //     let _entityMap = _draftjs.entityMap
  //
  //     for ( let i=0; i<_blocks.length; i++ ) {
  //
  //       let _block = _blocks[i]
  //       let _words = _block.data.words
  //
  //       let _current_block_index = props.blockIndexes[0] + i
  //
  //       if (_current_block_index < props.playingBlockIndex) {
  //
  //         // past ...
  //         _draftjs.blocks[i].inlineStyleRanges = [
  //           {
  //             _id: "pre",
  //             length: _draftjs.blocks[i].text.length,
  //             offset: 0,
  //             style : "REALTIME_PAST"
  //           },
  //         ]
  //
  //       } else if (_current_block_index === props.playingBlockIndex) {
  //
  //         if (!_entityMap) {
  //           continue
  //         }
  //         if ( Object.keys(_entityMap).length === 0 ) {
  //           continue
  //         }
  //
  //         // for ( let j=0; j<_entityMap.length; j++) {
  //         for ( let j in _entityMap ) {
  //
  //           let _item = _entityMap[j]
  //           // console.log("_entityMap._item: ", _item)
  //
  //           if (!_item.data) {
  //             console.log("_entityMap no data 1: ")
  //             continue
  //           }
  //
  //           let _start = _item.data.start
  //           let _end = _item.data.end
  //           let _length = _item.data.length
  //           let _offset = _item.data.offset
  //           // let _word = _item.data.word
  //
  //           // let _latestEnd = _end
  //
  //           if (props.playerCurrentTime >= _start && props.playerCurrentTime <= _end+0.04) {
  //
  //             let range_id = i+'-'+j+'-'+_offset+"-"+_length
  //             // console.log("range_id: ", range_id)
  //
  //             let _exists = false
  //             for ( let k=0; k<_draftjs.blocks[i].inlineStyleRanges.length; k++ ) {
  //               if ( _draftjs.blocks[i].inlineStyleRanges[k]._id === range_id) {
  //                 _exists = true
  //                 break
  //               }
  //             }
  //             // console.log("_exists: ", _exists)
  //
  //             if (_exists === false ) {
  //
  //               _draftjs.blocks[i].inlineStyleRanges = [
  //                 {
  //                   _id: "pre",
  //                   length: _offset,
  //                   offset: 0,
  //                   style : "REALTIME_PAST"
  //                 },
  //                 {
  //                   _id: range_id,
  //                   length: _length,
  //                   offset: _offset,
  //                   style : "REALTIME_NOW"
  //                 },
  //               ]
  //             }
  //           }
  //         }
  //       }
  //     }
  //
  //     let _state = convertFromRaw(_draftjs);
  //     setEditorState(EditorState.createWithContent(_state))
  //
  //   } else {
  //
  //     let _max = props.blockIndexes[props.blockIndexes.length-1]
  //     if (_max < props.playingBlockIndex) {
  //
  //
  //       // let _draftjs = props.item.draftjs
  //       let _draftjs = convertToRaw(editorState.getCurrentContent())
  //       let _blocks = _draftjs.blocks
  //       // let _entityMap = _draftjs.entityMap
  //
  //       for ( let i=0; i<_blocks.length; i++ ) {
  //
  //         // past ...
  //         _draftjs.blocks[i].inlineStyleRanges = [
  //           {
  //             _id: "pre",
  //             length: _draftjs.blocks[i].text.length,
  //             offset: 0,
  //             style : "REALTIME_PAST"
  //           },
  //         ]
  //       }
  //
  //       let _state = convertFromRaw(_draftjs);
  //       setEditorState(EditorState.createWithContent(_state))
  //     }
  //   }
  //
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [props.playingBlockIndex, props.playerCurrentTime]);


  /// draft.js rich editor

  // _handleKeyCommand
  let _handleKeyCommand = (command, editorState) => {

    const newState = RichUtils.handleKeyCommand(editorState, command);

    if (newState) {
      setEditorState(newState);
      return 'handled';
    }

    return 'not-handled';
  }

  // https://github.com/facebook/draft-js/blob/010fce785948edaf92bd9e81e8777784c1421545/src/model/immutable/SampleDraftInlineStyle.js
  let _onBoldClick = () => {
    setEditorState(RichUtils.toggleInlineStyle(editorState, 'BOLD'))
  }

  // _onHighlight
  let _onHighlight = () => {
    setEditorState(RichUtils.toggleInlineStyle(editorState, 'HIGHLIGHT'))
  }

  let _onAddLink = () => {

    const selection = editorState.getSelection();
    const link = window.prompt('Paste the link -')
    if (!link) {
      setEditorState(RichUtils.toggleLink(editorState, selection, null));
      return 'handled';
    }
    const content = editorState.getCurrentContent();
    const contentWithEntity = content.createEntity('LINK', 'MUTABLE', { url: link });
    const newEditorState = EditorState.push(editorState, contentWithEntity, 'create-entity');
    const entityKey = contentWithEntity.getLastCreatedEntityKey();
    setEditorState(RichUtils.toggleLink(newEditorState, selection, entityKey))
  }

  // _toggleBlockType
  let _toggleBlockType = blockType => {
    setEditorState(RichUtils.toggleBlockType(editorState, blockType));
  };

  // let [lastUsedEntity, setLastUsedEntity] = useState(null)









  // onChange Editor
  let _onChange3 = (editorState_new) => {

    if (selectAndPlayTimeout) {
      clearTimeout(selectAndPlayTimeout)
      setSelectAndPlayTimeout(null)
    }

    // current content block state
    let content_state_old = editorState.getCurrentContent()
    // upcoming content block state
    let content_state_new = editorState_new.getCurrentContent()

    // check content has changed or not
    if (content_state_old === content_state_new) {

      // selected text current
      let selected_text_current = getSelectionText(editorState)
      // console.log("selected_text_current: ", selected_text_current)

      // selected text upcomping
      let selected_text_upcoming = getSelectionText(editorState_new)
      // console.log("selected_text_upcoming: ", selected_text_upcoming)

      if (!selected_text_current && selected_text_upcoming) {
        // text selected

        let _entityKey = getSelectionEntity(editorState_new)

        let _entity_list = getEntities(editorState_new)

        let _data = null
        for (let i=0; i<_entity_list.length; i++) {
          if (_entity_list[i].entityKey === _entityKey) {
            let _item = _entity_list[i]
            _data = _item.entity.getData()
          }
        }

        if (_data) {

          if (props.isPlaying === false ) {

            let _timeout = setTimeout(() => {

              // play
              props.togglePlayMediaFromWord({
                start_time: _data.start,
                end_time: _data.end,
              })

            }, 1500)

            // set select and play timeout
            setSelectAndPlayTimeout(_timeout)
          } else {

            props.stopPlayMediaFromWord()

          }
        }
      }

      // same
      setEditorState(editorState_new)

      return;
    }

    if (props.isPlaying === true ) {

      props.stopPlayMediaFromWord()
      // setEditorState(EditorState.undo(editorState_new))
      // return

      // // play
      // props.stopPlayMediaFromWord()
    }

    //upcoming
    let selection_state_new_b = content_state_new.selectionBefore
    let selection_state_new_a = content_state_new.selectionAfter

    // upcoming anchor keys
    let selection_state_new_b_key = selection_state_new_b.getAnchorKey()
    let selection_state_new_a_key = selection_state_new_a.getAnchorKey()
    // console.log("selection_state_new_b_key: ", selection_state_new_b_key)
    // console.log("selection_state_new_a_key: ", selection_state_new_a_key)

    // upcoming anchor offsets
    let selection_state_new_b_offset = selection_state_new_b.getAnchorOffset()
    let selection_state_new_a_offset = selection_state_new_a.getAnchorOffset()
    // console.log("selection_state_new_b_offset: ", selection_state_new_b_offset)
    // console.log("selection_state_new_a_offset: ", selection_state_new_a_offset)

    // upcoming focus offsets
    let selection_state_new_b_offset_f = selection_state_new_b.getFocusOffset()
    let selection_state_new_a_offset_f = selection_state_new_a.getFocusOffset()
    // console.log("selection_state_new_b_offset_f: ", selection_state_new_b_offset_f)
    // console.log("selection_state_new_a_offset_f: ", selection_state_new_a_offset_f)


    // current
    let selection_state_old_a = content_state_old.selectionBefore
    let selection_state_old_b = content_state_old.selectionAfter

    // current keys
    let selection_state_old_b_key = selection_state_old_b.getAnchorKey()
    let selection_state_old_a_key = selection_state_old_a.getAnchorKey()
    // console.log("selection_state_old_b_key: ", selection_state_old_b_key)
    // console.log("selection_state_old_a_key: ", selection_state_old_a_key)

    // current offsets
    let selection_state_old_b_offset = selection_state_old_b.getAnchorOffset()
    let selection_state_old_a_offset = selection_state_old_a.getAnchorOffset()
    // console.log("selection_state_old_b_offset: ", selection_state_old_b_offset)
    // console.log("selection_state_old_a_offset: ", selection_state_old_a_offset)

    // this parameter keep returning same if contet not changed
    let _lastType = editorState_new.getLastChangeType()
    // console.log("_lastType: ", _lastType)

    if (_lastType === "split-block") {
      console.log("split-block")

      setEditorState(EditorState.undo(editorState_new))
      return
    }

    if ( _lastType === "backspace-character") {
      console.log("backspace-character")

      let _entity_list = getEntities(editorState_new)
      // console.log("_entity_list.1: ", _entity_list)

      let _entityKey = getSelectionEntity(editorState)
      // console.log("_entityKey: ", _entityKey)

      let _exists = false
      for (let i=0; i<_entity_list.length; i++) {
        if (_entity_list[i].entityKey === _entityKey) {
          _exists = true
        }
      }

      if ( _exists === false && _entityKey ){
        // console.log("============ >>>>> wtf!")

        let selectionState = SelectionState.createEmpty(selection_state_new_b_key);

        let updatedSelection1 = selectionState.merge({
          focusOffset: selection_state_new_b_offset_f,
          anchorOffset: selection_state_new_a_offset,
        });

        let _entityKey = getSelectionEntity(editorState)

        // replace text
        let new_content_state1 = Modifier.replaceText(
          content_state_old,
          updatedSelection1,
          ' ',
          null,
          _entityKey,
        )

        let editor_state2 = EditorState.push(
          editorState,
          new_content_state1,
          'test1',
        )

        var updatedSelection2 = selectionState.merge({
          focusOffset: selection_state_new_a_offset+1,
          anchorOffset: selection_state_new_a_offset,
        });

        setEditorState(EditorState.forceSelection(editor_state2, updatedSelection2))
        return
      }
    } else if (_lastType === "remove-range") {

      console.log("remove-range")

      // selected text current
      let selected_text_current = getSelectionText(editorState)


      // スペースのみ
      // 文字のみ
      // 端っこにスペースがある
      // 中にスペースがある
      if (!selected_text_current.trim()) {
        // just space
        console.log("just space")

        // undo
        setEditorState(EditorState.undo(editorState_new))
        return

      } else if ( selected_text_current.indexOf(" ") === -1 ) {
        // no space at all
        console.log("no space at all")

        setEditorState(editorState_new)
        return

      } else if ( selected_text_current.trim().indexOf(" ") === -1 ) {
        console.log("space is corner")

        // undo
        setEditorState(EditorState.undo(editorState_new))
        return

      } else {
        console.log("space is inside")
        console.log("selected_text_current: ", selected_text_current, selected_text_current.length)


        // upcoming anchor offsets
        console.log("selection_state_new_b_offset: ", selection_state_new_b_offset)
        console.log("selection_state_new_a_offset: ", selection_state_new_a_offset)

        // upcoming focus offsets
        console.log("selection_state_new_b_offset_f: ", selection_state_new_b_offset_f)
        console.log("selection_state_new_a_offset_f: ", selection_state_new_a_offset_f)


        // current keys
        console.log("selection_state_old_b_key: ", selection_state_old_b_key)
        console.log("selection_state_old_a_key: ", selection_state_old_a_key)

        // current offsets
        console.log("selection_state_old_b_offset: ", selection_state_old_b_offset)
        console.log("selection_state_old_a_offset: ", selection_state_old_a_offset)
      }


      // // selected text upcomping
      // let selected_text_upcoming = getSelectionText(editorState_new)
      // console.log("selected_text_upcoming: ", selected_text_upcoming)

    }

    setEditorState(editorState_new)
  }


  // get text remain
  let _diff_remain_parts = (text_new, text_orig) => {

    let _diff0 = Diff.diffChars(text_new, text_orig)

    let _remains1 = ""
    let _end_detected1 = false
    for ( let i=0; i<_diff0.length; i++ ) {

      if (!_diff0[i].added && !_diff0[i].removed) {
        if (_end_detected1 === false) {
          _remains1 = _remains1 + _diff0[i].value
        }
      } else {
        _end_detected1 = true
      }
    }

    if ( text_orig.indexOf(_remains1) === -1 ) {
      _remains1 = ""
    }
    // console.log("11 _remains1: ", _remains1)

    if (_remains1) {
      return _remains1
    }

    // reverse
    // let _remains2 = ""
    let _end_detected2 = false
    for ( let i=_diff0.length-1; i>0; i-- ) {

      if (!_diff0[i].added && !_diff0[i].removed) {
        if (_end_detected2 === false) {
          _remains1 = _diff0[i].value + _remains1
        }
      } else {
        _end_detected2 = true
      }
    }

    // console.log("22 _remains1: ", _remains1)

    if ( text_orig.indexOf(_remains1) === -1 ) {
      _remains1 = ""
    }

    return _remains1
  }


  let _entireTextsAreDeleted = (blocks) => {

    let _texts_all = ""
    for ( let i=0; i<blocks.length; i++ ) {
      let _block = blocks[i]
      let _text = _block.text
      _texts_all = _texts_all + _text
    }
    // _texts_all = _texts_all.trim()

    if (!_texts_all) {
      return true
    } else {
      return false
    }
  }

  // submit btn
  // let _submitPost = () => {
  //
  //   let contentState = editorState.getCurrentContent()
  //   let contentStateRaw = convertToRaw(contentState)
  //   let contentStateRawStringified = JSON.stringify(contentStateRaw)
  //
  //   // get texts
  //   let blocks = contentStateRaw.blocks;
  //   let _transcript = blocks.map(block => (!block.text.trim() && '\n') || block.text).join(' ');
  //
  //   // props.submitPost({
  //   //   healthScore: healthScore,
  //   //   contentStateRawStringified: contentStateRawStringified,
  //   //   transcript_upd: _transcript,
  //   // })
  // }

  // test
  let _test = () => {

    let rawData = convertToRaw(editorState.getCurrentContent())
    console.log("rawData: ", rawData)
    console.log("")
  }

  // // _handlePastedText
  // let _handlePastedText = () => {
  //   return "handled"
  // }

  // make selection ok
  let _makeSelectionOk = () => {
    setEditorState(RichUtils.toggleInlineStyle(editorState, 'HIGHLIGHT_OK'))
  }

  // // make selection ok
  // let _makeSelectionNotOk = () => {
  //   setEditorState(RichUtils.toggleInlineStyle(editorState, 'HIGHLIGHT_NOT_OK'))
  // }
  //
  // // make selection dictonary
  // let _makeSelectionDict = () => {
  //   setEditorState(RichUtils.toggleInlineStyle(editorState, 'HIGHLIGHT_DICT'))
  // }
  //
  //
  // // make selection Head
  // let _makeSelectionH = () => {
  //   setEditorState(RichUtils.toggleBlockType(editorState, "header-two"));
  // }
  //
  //
  // let _hiraganaChanged = (e) => {
  //   setHiragana(e.target.value)
  // }
  //
  // // _wordCategoryChanged
  // let _wordCategoryChanged = (e) => {
  //   setWordCategory(e.target.value)
  // }


  // @draft-js-plugins experiments

  // focus
  let _focus = () => {
    if (editor.current) {
      editor.current.focus();
    }
  }

  // make selection ok
  let _sampleButtonClicked = () => {
    console.log("_sampleButtonClicked!!!")
    // setEditorState(RichUtils.toggleInlineStyle(editorState, 'HIGHLIGHT_NOT_OK'))
    setEditorState(RichUtils.toggleInlineStyle(editorState, 'HIGHLIGHT_DICT'))
  }

  // make selection ok
  let _strikethroughButtonClicked = () => {
    console.log("_strikethroughButtonClicked!!!")
    setEditorState(RichUtils.toggleInlineStyle(editorState, 'STRIKETHROUGH'))
    // setEditorState(RichUtils.toggleInlineStyle(editorState, 'REALTIME_PAST'))
  }

  // make selection ok
  let _playButtonClicked = () => {
    console.log("_playButtonClicked!!!")

    let _entityKey = getSelectionEntity(editorState)
    console.log("_entityKey: ", _entityKey)

    let _entity_list = getEntities(editorState)

    let _data = null
    for (let i=0; i<_entity_list.length; i++) {
      if (_entity_list[i].entityKey === _entityKey) {
        let _item = _entity_list[i]
        // console.log("_item: ", _item)
        _data = _item.entity.getData()
        // console.log("_data: ", _data)
      }
    }
    console.log("_data: ", _data)

    if (_data) {

      // play
      props.togglePlayMediaFromWord({
        start_time: _data.start,
        end_time: _data.end,
      })
    }
  }

  let _updownButtonClicked = () => {
    console.log("_updownButtonClicked!!!")

    console.log("_playButtonClicked!!!")

    let _entityKey = getSelectionEntity(editorState)
    console.log("_entityKey: ", _entityKey)

    let _entity_list = getEntities(editorState)

    let _entity = null
    let _data = null
    for (let i=0; i<_entity_list.length; i++) {
      if (_entity_list[i].entityKey === _entityKey) {
        _entity = _entity_list[i]
        // console.log("_item: ", _item)
        _data = _entity.entity.getData()
        // console.log("_data: ", _data)

      }
    }
    console.log("_entity: ", _entity)
    console.log("_data: ", _data)

    if (!_entity) {
      return;
    }
    if (!_data) {
      return
    }

    let selected_text = getSelectionText(editorState)
    selected_text = selected_text.trim()

    let contentState = editorState.getCurrentContent()
    let block_state_new = contentState.getBlockForKey(_entity.blockKey)
    let _text = block_state_new.getText()
    _text = _text.trim()

    //
    if ( _text.endsWith(selected_text) === true ) {

      props.reCreateChunks({
        word: selected_text,
        blockKey:_entity.blockKey,
        end_time: _data.end,
        start_time: _data.start,
        position: 'end',
        offset: _entity.start,
      })
    }
  }

  return (
    <div>

      {/* editor */}
      <Row style={{
        marginTop: 20,
        marginBottom: 20,
      }}>
        <Col md="12" xs="12" onClick={_focus} className="editor">
          <Editor
            ref={(element) => {
              editor.current = element;
            }}
            plugins={plugins}
            editorState={editorState}
            onChange={_onChange3} />

            <InlineToolbar>
              {
                // may be use React.Fragment instead of div to improve perfomance after React 16
                (externalProps) => (
                  <div>
                    <SampleButton
                      sampleButtonClicked={_sampleButtonClicked}
                      {...externalProps} />

                    <StrikethroughButton
                      sampleButtonClicked={_strikethroughButtonClicked}
                      {...externalProps} />

                    <PlayButton
                      isPlaying={props.isPlaying}
                      sampleButtonClicked={_playButtonClicked}
                      {...externalProps} />

                    <UpDownButton
                      sampleButtonClicked={_updownButtonClicked}
                      {...externalProps} />

                  </div>
                )
              }
            </InlineToolbar>

        </Col>
      </Row>

    </div>
  )
});

export default NaranciaEditor8
